import { repairStatusConfig } from '@/constants/repair'
import { useUI } from '@/hooks/useUI'

const fallbackConfig = { color: 'text-muted-foreground', bgColor: 'bg-muted/15' }

export function RepairStatusBadge({ status }: { status: string }) {
  const { repairStatuses, getEnumLabel } = useUI()
  const config = repairStatusConfig[status] ?? fallbackConfig
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-medium ${config.bgColor} ${config.color}`}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {getEnumLabel(repairStatuses, status, status)}
    </span>
  )
}
